import React from 'react';

interface InvoiceIconProps {
  color?: string;
}

const InvoiceIcon: React.FC<InvoiceIconProps> = ({ color }) => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          className=""
          clipRule="evenodd"
          d="M13.2519 0.426854C13.5853 0.236381 14 0.477064 14 0.860976V17.1378C14 17.5217 13.5853 17.7624 13.2519 17.5719L10.9961 16.2829C10.6887 16.1072 10.3113 16.1072 10.0039 16.2829L7.79382 17.5458C7.30193 17.8269 6.69807 17.8269 6.20618 17.5458L3.99614 16.2829C3.68871 16.1072 3.31129 16.1072 3.00386 16.2829L0.74807 17.5719C0.414741 17.7624 0 17.5217 0 17.1378V0.860976C0 0.477064 0.414741 0.236381 0.74807 0.426854L3.00386 1.71588C3.31129 1.89155 3.68871 1.89155 3.99614 1.71588L6.20618 0.452998C6.69807 0.171917 7.30193 0.171917 7.79382 0.452999L10.0039 1.71588C10.3113 1.89155 10.6887 1.89155 10.9961 1.71588L13.2519 0.426854ZM4.5 5.99939C4.22386 5.99939 4 6.22324 4 6.49939C4 6.77553 4.22386 6.99939 4.5 6.99939H9.5C9.77614 6.99939 10 6.77553 10 6.49939C10 6.22324 9.77614 5.99939 9.5 5.99939H4.5ZM4.5 8.49939C4.22386 8.49939 4 8.72324 4 8.99939C4 9.27553 4.22386 9.49939 4.5 9.49939H9.5C9.77614 9.49939 10 9.27553 10 8.99939C10 8.72324 9.77614 8.49939 9.5 8.49939H4.5ZM4.5 10.9994C4.22386 10.9994 4 11.2232 4 11.4994C4 11.7755 4.22386 11.9994 4.5 11.9994H9.5C9.77614 11.9994 10 11.7755 10 11.4994C10 11.2232 9.77614 10.9994 9.5 10.9994H4.5Z"
          fill={color || 'currentColor'}
        />
      </svg>
    </>
  );
};
export { InvoiceIcon };
